import React, { useEffect, useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'
import './SwiperComponent.css'

const SwiperComponent = ({ destinations, onSelect }) => {
  const swiperRef = useRef(null)

  const updateSlideTransforms = () => {
    if (!swiperRef.current || !swiperRef.current.slides) return

    const swiper = swiperRef.current
    const slides = swiper.slides
    const activeIndex = swiper.realIndex
    const totalSlides = destinations.length

    slides.forEach(slide => {
      const slideIndex = parseInt(slide.getAttribute('data-swiper-slide-index'))
      let relativeIndex = slideIndex - activeIndex

      if (relativeIndex < -totalSlides / 2) relativeIndex += totalSlides
      if (relativeIndex > totalSlides / 2) relativeIndex -= totalSlides

      const single = slide.querySelector('.single')
      if (!single) return

      if (relativeIndex < 0) {
        const translateY = Math.abs(relativeIndex) * 40
        const rotate = relativeIndex * 2
        single.style.transform = `translate(0px, ${translateY}px) rotate(${rotate}deg)`
        single.style.transformOrigin = 'right top'
      } else if (relativeIndex > 0) {
        const translateY = relativeIndex * 40
        const rotate = relativeIndex * 2
        single.style.transform = `translate(0px, ${translateY}px) rotate(${rotate}deg)`
        single.style.transformOrigin = 'left top'
      } else {
        single.style.transform = `translate(0px, 0px) rotate(0deg)`
        single.style.transformOrigin = 'center top'
      }
    })
  }

  useEffect(() => {
    if (swiperRef.current) {
      updateSlideTransforms()
    }
  }, [swiperRef.current])

  return (
    <div style={{ padding: '20px' }} className='SwiperComponent'>
      <h1>Top Trending Destinations</h1>
      <h4>Have your dream stay at top Flights worldwide</h4>
      <Swiper
        modules={[Pagination, Autoplay]}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        breakpoints={{
          320: { slidesPerView: 2, spaceBetween: 20 },
          768: { slidesPerView: 3, spaceBetween: 40 },
          1024: { slidesPerView: 5, spaceBetween: 80 }
        }}
        centeredSlides={true}
        loop={true}
        pagination={{ clickable: true }}
        onSwiper={swiper => {
          swiperRef.current = swiper
          setTimeout(updateSlideTransforms, 0)
        }}
        onSlideChange={() => updateSlideTransforms()}
        style={{ height: '500px', cursor: 'grab' }}
      >
        {destinations.map((destination, index) => (
          <SwiperSlide
            key={index}
            style={{
              width: '124.4px',
              marginRight: '80px',
              textAlign: 'center'
            }}
            onClick={() => onSelect(destination.name)}
          >
            <div className='single getcallback2' place={destination.name}>
              <div className='global-img'>
                <img
                  src={destination.image}
                  style={{ borderRadius: '10px' }}
                  alt={destination.name}
                />
              </div>
              <div className='slide-data'>
                <div
                  style={{
                    color: 'white',
                    textAlign: 'center',
                    marginTop: '10px'
                  }}
                >
                  {destination.name}
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default SwiperComponent
